import { REMOVE_LAST_ISSUE } from 'actions';

export function removeLastIssue() {
  return { type: REMOVE_LAST_ISSUE };
}
